import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      // Mock subscription
      toast({
        title: "Subscribed!",
        description: "Thank you for subscribing to our newsletter.",
      });
      setEmail('');
    }
  };

  return (
    <section className="section-padding newsletter-section" id="newsletter">
      <div className="container">
        <div className="newsletter-content">
          <div className="newsletter-text">
            <Mail className="newsletter-icon" />
            <h2 className="heading-2">Stay Updated</h2>
            <p className="body-regular" style={{ marginTop: '12px', color: 'var(--text-secondary)' }}>
              Subscribe to receive updates on upcoming shows and exclusive offers
            </p>
          </div>
          
          <form className="newsletter-form" onSubmit={handleSubmit}>
            <input
              type="email"
              className="newsletter-input"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="btn-primary" style={{ minWidth: '140px' }}>
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;